<template>
  <div :class="classNames" v-on:click="onHeadlineClick(id)">
    {{headline || group || name || project_name || client_name || 'N/A'}} <span v-if="article_count" class="text-sm">({{article_count}})</span>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    getProps: Function
  },

  data: function() {
    const props = typeof this.getProps === 'function' ? this.getProps() : this.$attrs;
    const { id, headline, group, name, project_name, client_name, onClick, article_count } = props;
    const isButton = _.isFunction(onClick) || props.isButton === true;

    return {
      id,
      headline,
      group,
      name,
      project_name,
      client_name,
      article_count,
      onClick,
      isButton,
      classNames: {
        'headline-wrapper': true,
        'headline--button': isButton
      }
    }
  },

  methods: {
    onHeadlineClick: function(id) {
      if (this.isButton && typeof this.onClick === 'function') {
        this.onClick(id);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .headline-wrapper {
    //max-width: 390px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #ec9148;
    font-size: 14px;

    &.headline--button {
      cursor: pointer;
    }
    &:hover {
      opacity: 0.6;
      color: #27a8b1;
    }
  }
</style>